import React, { useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import { List } from 'components/pages-article-list/list';
import { Pagination } from 'components/utils/pagination';
import { SideMenu } from 'components/utils/side-menu';
import { handleError } from 'config/libraries';

export const Section3 = () => {

    const [DataResponse, setDataResponse] = useState(null);

    useEffect(() => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/artikel?per_page=5&page=1').then(function (response) {
            setDataResponse(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
    }, []);

    return (
		<section className="home_section3">
			<div className="container">
				<div className="row">
				<div className="col-md-12">
					<div className="jl_sec_title">
						<h3 className="jl_title_c">Artikel</h3>
						<p>Artikel resmi dari Dinas Pendidikan</p>
					</div>
					{
						(DataResponse != null && DataResponse.length > 0) ? 
						<div className="jl_mg_wrapper jl_clear_at">
						<div className="jl_mg_post jl_clear_at">
							<div className="jl_mg_main">
								<div className="jl_mg_main_w">
									<div className="jl_img_box jl_radus_e">
									<Link to={'/artikel/' + DataResponse[0].slug_artikel}>
										<img width={1000} height={650} src={process.env.REACT_APP_SERVER_IMAGE_URL + DataResponse[0].gambar_artikel} className="attachment-sprasa_feature_large size-sprasa_feature_large wp-post-image" alt="" loading="lazy" />
									</Link>
									<span className="jl_f_cat"><Link to={'/artikel/' + DataResponse[0].slug_artikel} className="post-category-color-text" style={{background: '#4dcf8f'}} href="#">{DataResponse[0].nama_kategori_artikel}</Link></span>
									</div>
									<div className="text-box">
									<h3 className="entry-title"><Link to={'/artikel/' + DataResponse[0].slug_artikel} tabIndex={-1}>{DataResponse[0].judul_artikel}</Link></h3>
									<span className="jl_post_meta">
										<span className="post-date"><i className="jli-pen" />{DataResponse[0].created_at}</span>
									</span>
									<p>
										{DataResponse[0].sub_judul_artikel}
									</p>
									</div>
								</div>
							</div>
							{
								DataResponse && DataResponse.map((item, index) => {
									if (index > 0) {
										return (
											<div key={index} className="jl_mg_sm">
												<div className="jl_mg_sm_w">
													<div className="jl_f_img jl_radus_e">
													<Link to={'/artikel/' + item.slug_artikel}>
														<img width={1000} height={650} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_artikel} className="attachment-sprasa_feature_large size-sprasa_feature_large wp-post-image" alt="" loading="lazy" />
													</Link>
													<span className="jl_f_cat"><Link to={'/artikel/' + item.slug_artikel} className="post-category-color-text" style={{background: '#d66300'}} href="#">{item.nama_kategori_artikel}</Link></span>
													</div>
													<div className="jl_mg_content">
													<h3 className="entry-title"><Link to={'/artikel/' + item.slug_artikel} href="#">{item.judul_artikel}</Link></h3>
													<span className="jl_post_meta">
														<span className="post-date"><i className="jli-pen" />{item.created_at}</span>
													</span>
													</div>
												</div>
												</div>
										)
									}
									
								})
							}
						</div>
					</div> : ''
					}
				</div>
				</div>
			</div>
        </section>
    )
};